import { render, staticRenderFns } from "./StrategyPage.vue?vue&type=template&id=ffc758c6&"
import script from "./StrategyPage.vue?vue&type=script&lang=js&"
export * from "./StrategyPage.vue?vue&type=script&lang=js&"
import style0 from "./StrategyPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports